import { ConfigurationEntry } from "@/model/communication/application/GetServerConfigurationResponse";
import { ApplicationStartupData } from "@/model/communication/application/StartupData";
import { Branch } from "@/model/data/Branch";
import { Denomination } from "@/model/data/Denomination";
import { TagValues } from "@/model/data/Tag";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { ApplicationState } from ".";

export const SET_APP_STATUS = "SET_APP_STATUS";
export const SET_DRAWER = "SET_DRAWER";
export const REFRESH_MENU = "REFRESH_MENU";
export const SET_APPLICATION_LOADED = "SET_APPLICATION_LOADED";
export const SET_SUPPORTED_MODELS = "SET_SUPPORTED_MODELS";
export const SET_STARTUP_DATA = "SET_STARTUP_DATA";
export const SET_SERVER_CONFIGURATION = "SET_SERVER_CONFIGURATION";
export const SET_TV_MODE = "SET_TV_MODE";

// For filters
export const SET_AVAILABLE_BRANCHES = "SET_AVAILABLE_BRANCHES";
export const SET_AVAILABLE_BRANCHES_INCLUDE_EMPTY = "SET_AVAILABLE_BRANCHES_INCLUDE_EMPTY";
export const SET_AVAILABLE_BRANCHES_INCLUDE_DELETED = "SET_AVAILABLE_BRANCHES_INCLUDE_DELETED";
export const SET_AVAILABLE_MACHINE_MODELS = "SET_AVAILABLE_MACHINE_MODELS";
export const SET_AVAILABLE_SOFTWARE_VERSIONS = "SET_AVAILABLE_SOFTWARE_VERSIONS";
export const SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING = "SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING";
export const SET_AVAILABLE_SOFTWARE_VERSIONS_TYPE = "SET_AVAILABLE_SOFTWARE_VERSIONS_TYPE";
export const SET_AVAILABLE_TAGS = "SET_AVAILABLE_TAGS";
export const SET_MODEL_TREE = "SET_MODEL_TREE";

//Denominations
export const SET_ALL_DENOMINATIONS = "SET_ALL_DENOMINATIONS";

// Application events
export const OPEN_DEVICE_TREE_TO_FOLDER_ID = "OPEN_DEVICE_TREE_TO_FOLDER_ID";

export default {
    // Set Drawer
    [SET_DRAWER](state, payload) {
        state.drawer = payload;
    },

    // // Imposta l'utente autenticato
    // [SET_AUTH_USER](state, payload) {
    //     Vue.set(state.auth, "user", payload);
    // },

    [SET_APPLICATION_LOADED](state, applicationLoaded) {
        state.applicationLoaded = applicationLoaded;
    },

    [SET_SUPPORTED_MODELS](state, models) {
        state.supportedModels = models;
    },

    // For filters
    [SET_AVAILABLE_BRANCHES](state, branches: Branch[]) {
        state.availableBranches = branches;
    },
    [SET_AVAILABLE_BRANCHES_INCLUDE_EMPTY](state, branches: Branch[]) {
        state.availableBranchesIncludeEmpty = branches;
    },
    [SET_AVAILABLE_BRANCHES_INCLUDE_DELETED](state, payload) {
        state.availableBranchesIncludeDeleted = payload.branches;
        payload.deletedBranches.forEach((b) => {
            let branch = new Branch();
            branch.name = b;
            branch.deleted = true;
            state.availableBranchesIncludeDeleted.push(branch);
        });
    },

    [SET_AVAILABLE_MACHINE_MODELS](state, models: string[]) {
        state.availableMachineModels = models;
    },
    [SET_AVAILABLE_SOFTWARE_VERSIONS](state, value: SoftwareFilter[]) {
        state.availableSoftwareVersions = value;
    },
    [SET_AVAILABLE_SOFTWARE_VERSIONS_FETCHING](state, value: boolean) {
        state.availableSoftwareVersionsFetching = value;
    },
    [SET_AVAILABLE_SOFTWARE_VERSIONS_TYPE](state, value: string) {
        state.availableSoftwareVersionsType = value;
    },
    [SET_AVAILABLE_TAGS](state, value: TagValues[]) {
        state.availableTags = value;
    },
    [OPEN_DEVICE_TREE_TO_FOLDER_ID](state, folderId: number) {
        state.openDeviceTreeToFolderIdEvent = folderId;
    },
    [SET_STARTUP_DATA](state, value: ApplicationStartupData) {
        state.startupData = value;
    },

    [SET_SERVER_CONFIGURATION](state: ApplicationState, configuration: ConfigurationEntry[]) {
        state.configurationEntries = [];
        configuration.forEach((entry) => {
            state.configurationEntries.push(entry);
        });
    },
    [SET_TV_MODE](state, value: boolean) {
        state.tvMode = value;
    },
    [SET_ALL_DENOMINATIONS](state, value: Denomination[]) {
        state.allDenominations = value;
    },
    [SET_MODEL_TREE](state, value: string) {
        state.modelTree = value;
    },
};
